import React from 'react';
import moment from 'moment';
import {
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	Heading,
	Tag,
} from '@chakra-ui/react';
import { Ticket } from './ticket';

const getDate = date => {
	if (!moment(date).isValid()) return '';
	return moment(date).format('DD.MM');
};

const getColor = date => {
	if (!moment(date).isValid()) return 'gray';
	const timeLeft = moment(date).unix() - moment().unix();
	if (timeLeft < 0) return 'black';
	if (timeLeft < 86400) return 'red';
	if (timeLeft >= 3 * 86400) return 'green';
	if (timeLeft >= 86400) return 'orange';

	return 'gray';
};

export const TicketsAccordion = ({
	tickets,
	workers,
	admin,
	setWakeTickets,
	setUserID,
}) => (
	<Accordion allowToggle>
		{tickets.map(ticket => (
			<AccordionItem>
				<h2>
					<AccordionButton>
						<Tag size="lg" bgColor={getColor(ticket.due_date)} color="white">
							{getDate(ticket.due_date)}
						</Tag>
						<Heading fontSize="lg" flex="1" textAlign="left" ml={3}>
							{`№${ticket.id} ${ticket.title}`}
						</Heading>
						<Tag size="lg">{ticket.assignee}</Tag>
						<AccordionIcon />
					</AccordionButton>
				</h2>
				<AccordionPanel pb={4}>
					<Ticket
						key={ticket.id}
						{...{
							ticket,
							workers,
							admin,
							setWakeTickets,
							withTitle: false,
							setUserID,
						}}
					/>
				</AccordionPanel>
			</AccordionItem>
		))}
	</Accordion>
);
